import React, { Component } from 'react';
import { withRouter,Link } from 'react-router-dom';
import classnames from 'classnames';

import styles from './styles.module.css';

import { slide as Menu } from 'react-burger-menu';

import mobileMenu from '../../../../assets/images/mobile-menu.svg';

class MobileMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }


    render() {

        const {
            logo,
            white,
            active,
            history: {
                location: {
                    pathname = '/',
                } = {}
            } ={},
            menus = []
        } = this.props;

        return (
            <div className={styles.main}>
                <div className={styles.menuTop}>
                    <img
                        src={mobileMenu}
                        className={styles.hamburguer}
                        onClick={() => this.setState((prevState) => ({ isOpen: !prevState.isOpen }))} />
                    <div className={styles.header}>
                        <img className={styles.logo} src={logo} />
                    </div>
                </div>
                <Menu isOpen={this.state.isOpen} >
                    {
                        menus.map(
                            ({ path, title }, index) => (
                                <div
                                    key={`menu-${index}`}
                                    className={classnames(styles.menuItem, pathname.indexOf(path) == 0 ? styles.active : '')}>
                                    <Link to={`${path}`}>{title}</Link>
                                </div>)
                        )
                    }
                </Menu>
            </div>
        );
    }
}

export default withRouter(MobileMenu);